var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDeleteRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 11,
    fill: "white",
    stroke: "#E5704C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30337 18.8787C8.89888 19.2692 8.89888 19.9024 9.30337 20.2929C9.70785 20.6834 10.3637 20.6834 10.7681 20.2929L14.7855 16.4142L19.2319 20.7071C19.6364 21.0976 20.2922 21.0976 20.6967 20.7071C21.1012 20.3166 21.1012 19.6834 20.6967 19.2929L16.2503 15L20.6967 10.7071C21.1012 10.3166 21.1012 9.68342 20.6967 9.29289C20.2922 8.90237 19.6364 8.90237 19.2319 9.29289L14.7855 13.5858L10.7681 9.70711C10.3637 9.31658 9.70785 9.31658 9.30337 9.70711C8.89888 10.0976 8.89888 10.7308 9.30337 11.1213L13.3207 15L9.30337 18.8787Z",
    fill: "#E5704C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteRed);
export default __webpack_public_path__ + "static/media/icon_delete_red.6f469bc93b6830c6bb4564813453149d.svg";
export { ForwardRef as ReactComponent };